import Layout from "@/components/feature/Layout";
import SectionHeader from "@/components/base/SectionHeader";
import CTAButton from "@/components/base/CTAButton";
import FinalCta from "@/pages/home/components/FinalCta";

const services = [
  {
    num: "01",
    icon: "ri-global-line",
    title: "Websites",
    intro: "Professional websites that turn visitors into customers.",
    body: "Your website is often the first impression people have of your business. We design and build fast, responsive websites that look premium, communicate clearly and drive real results.",
    items: [
      "Corporate websites",
      "Business websites",
      "Landing pages",
      "E-commerce",
      "Website redesign",
      "SEO-ready websites",
      "Performance optimization",
    ],
  },
  {
    num: "02",
    icon: "ri-code-box-line",
    title: "Custom Software",
    intro: "Digital systems designed around the way your organization works.",
    body: "Off-the-shelf tools rarely fit how your organization actually operates. We build custom web applications and systems that match your processes — not the other way around.",
    items: [
      "Web applications",
      "Customer portals",
      "Management systems",
      "Dashboards",
      "Internal business tools",
      "Workflow systems",
      "API integrations",
    ],
  },
  {
    num: "03",
    icon: "ri-robot-2-line",
    title: "Automation & AI",
    intro: "Reduce repetitive work and make your business smarter.",
    body: "Manual, repetitive tasks slow your team down and introduce errors. We help you automate processes and integrate AI-powered features that make your operations faster and smarter.",
    items: [
      "Business process automation",
      "AI-powered features",
      "Intelligent workflows",
      "Data processing",
      "AI assistants",
      "API integrations",
      "Automated reporting",
    ],
  },
  {
    num: "04",
    icon: "ri-refresh-line",
    title: "Digital Transformation",
    intro: "Turn manual processes into connected digital experiences.",
    body: "Moving from paper and spreadsheets to connected digital systems is a journey. We help organizations digitize processes, integrate systems and modernize the way they work.",
    items: [
      "Digital strategy",
      "Process digitization",
      "System integration",
      "Legacy process modernization",
      "Custom platforms",
      "Technology consulting",
    ],
  },
];

export default function Services() {
  return (
    <Layout>
      <div className="pt-16 md:pt-[72px]">
        <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
          <div className="mx-auto max-w-[1280px]">
            <SectionHeader
              eyebrow="Services"
              title="What We Build"
              subtitle="From your first website to a complete digital platform, we build technology around your goals — not the other way around."
            />
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
          <div className="mx-auto max-w-[1280px] flex flex-col gap-10">
            {services.map((s, i) => (
              <div
                key={s.num}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-8 items-start ${
                  i % 2 === 1 ? "lg:grid-flow-dense" : ""
                }`}
              >
                <div className="lg:col-span-5">
                  <div className="flex items-center gap-3">
                    <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                      <i className={`${s.icon} text-2xl`}></i>
                    </span>
                    <span className="font-heading text-3xl font-bold text-primary-200">
                      {s.num}
                    </span>
                  </div>
                  <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {s.title}
                  </h2>
                  <p className="mt-3 text-lg font-medium text-foreground-800">
                    {s.intro}
                  </p>
                  <p className="mt-3 text-foreground-600 leading-relaxed">
                    {s.body}
                  </p>
                  <div className="mt-6">
                    <CTAButton to="/contact" variant="dark" icon="ri-arrow-right-up-line">
                      Discuss This
                    </CTAButton>
                  </div>
                </div>

                <div className="lg:col-span-7">
                  <div className="rounded-lg border border-background-200 bg-background-50 p-7">
                    <h3 className="font-heading text-sm font-semibold text-foreground-500 uppercase tracking-wide">
                      What's included
                    </h3>
                    <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {s.items.map((item) => (
                        <div
                          key={item}
                          className="flex items-start gap-2.5 text-foreground-700 text-sm"
                        >
                          <i className="ri-check-line text-primary-500 mt-0.5"></i>
                          <span>{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <FinalCta />
      </div>
    </Layout>
  );
}